/**
 * Tells whether a facility is subscribed to the Protect Plus program. Reads the protectPlus flag off the facility's programs object.
 *
 * @param programs - Facility programs object.
 * @returns The protectPlus subscription flag.
 */
const isFacilitySubscribeProtectPlus = (programs: any) => programs?.protectPlus;

/**
 * Tells whether a facility is subscribed to the Renewal Stock program. Reads the renewalStock flag off the facility's programs object.
 *
 * @param programs - Facility programs object.
 * @returns The renewalStock subscription flag.
 */
const isFacilitySubscribeRenewalStock = (programs: any) => programs?.renewalStock;

export { isFacilitySubscribeProtectPlus, isFacilitySubscribeRenewalStock };
